import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { Kopfzeile } from "../me/index.js";
import { normalisiereUmgebung, umgebungsAnsage } from "../umgebung.js";
import "./MeKopfleiste.css";
export const KopfRahmenKontext = createContext(null);
/**
 * Die Kopfleiste des Kundeninfosystems als `me-kopfzeile` (me-design).
 *
 * Keine eigene Farbe am Host: Grund und Schrift der Welt setzt das Element selbst über
 * sein Attribut `welt` und die ME-Tokens `--umgebung-*`; die Akzentlinie ist `--marke`
 * und folgt damit dem Arbeitsunternehmen (`data-unternehmen`). Das Element steht fest
 * (sticky) und setzt `role="banner"` selbst — hier kommt nur die Ansage dazu.
 */
export function MeKopfleiste(p) {
    const rahmen = useContext(KopfRahmenKontext);
    const welt = normalisiereUmgebung(p.umgebung.klasse);
    const ansage = p.ansage ?? umgebungsAnsage({
        klasse: welt,
        instanz: p.umgebung.instanz,
        konflikt: p.umgebung.konflikt === true,
    });
    const klassen = rahmen === null ? "ki-kopf" : `ki-kopf ${rahmen.klassen}`;
    return (_jsx(Kopfzeile, { className: klassen, welt: welt, "aria-label": ansage, titel: _jsxs(_Fragment, { children: [rahmen?.vorn, p.titel] }), wechsler: p.wechsler, werkzeuge: p.werkzeuge }));
}
//# sourceMappingURL=MeKopfleiste.js.map